import * as React from 'react';

interface Props {
  ariaName?: string;
}

export const CheckMark: React.FC<Props> = ({ ariaName }) => {
  return (
    <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>{ariaName}</title>
      <path d="M1 4.23077L3.60526 7L9.25 1" stroke="white" strokeWidth="1.5" />
    </svg>
  );
};
